/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';
import Helmet from 'react-helmet';
import { Spin, Icon, Row, Col } from 'antd';
import * as metadata from './metadata';
import { Menu, Avatar, Dropdown } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import Cookies from 'universal-cookie';
import auth from './sharedComponent/Auth';
import { get, logout } from './utils/httpRequests';
import { APIs } from './utils/apis';

const cookies = new Cookies();

const { SubMenu } = Menu;

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const LoadableLogin = Loadable({
  loader: () => import(/* webpackChunkName: 'login' */ './components/Login'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableValidateLogin = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'validateLogin' */ './components/ValidateLogin'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableJobs = Loadable({
  loader: () => import(/* webpackChunkName: 'jobs' */ './components/Jobs'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableAlerts = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'alerts' */ './components/Alerts/Alerts'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableEDD = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'alerts' */ './components/Alerts/Edd'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableStatusMapping = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'statusMapping' */ './components/StatusMapping'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableWarehouseMapping = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'warehouseMapping' */ './components/WarehouseMapping'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableReportMetadata = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'activeReports' */ './components/Reports/ReportMetadata'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableTimezoneSetting = Loadable({
  loader: () => import('./components/Reports/TimezoneSetting'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableFeatureRequests = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'activeReports' */ './components/FeatureRequests'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableNPSConfig = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'npsConfig' */ './components/NPSConfig'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableActiveReports = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'activeReports' */ './components/Reports/ActiveReports'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableShipmentLog = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'shipmentLog' */ './components/ShipmentLog'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableShippingLabels = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'shippingLabels' */ './components/ShippingLabel'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableCreateShippingLabels = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createShippingLabels' */ './components/CreateShippingLabel'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableQcParameters = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createShippingLabels' */ './components/Returns/QcParameter'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableReturnConfigs = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createShippingLabels' */ './components/Returns/Configs'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableSampleTemplates = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'sampleTemplates' */ './components/SampleTemplates'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});
const LoadableEmailTemplate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'emailTemplate' */ './components/EmailTemplate'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableReleaseNotes = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'emailTemplate' */ './components/ReleaseNotes'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableCreateEmailTemplate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createEmailTemplate' */ './components/CreateEmailTemplate'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableCreateSampleTemplate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createSampleTemplate' */ './components/CreateSampleTemplate'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableRegenerateShippingLabel = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'regenerateShippingLabel' */ './components/RegenerateShippingLabel'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableEditShippingLabels = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'editShippingLabels' */ './components/EditShippingLabel'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableBilling = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'billing' */ './components/Billing'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableSetupBilling = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'setupBilling' */ './components/SetupBilling'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableBillingAlerts = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'BillingAlerts' */ './components/Dashboard/BillingAlerts/List'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableBillingCreateAlerts = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'BillingCreateAlerts' */ './components/Dashboard/BillingAlerts/Create'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableSetupPayment = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'setupPayment' */ './components/SetupPayment'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableTrackingDelay = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'trackingDelay' */ './components/TrackingDelay'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableOrderCreationStats = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'orderCreationStats' */ './components/OrderCreationStats'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableDashboardLogin = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'dashboardLogin' */ './components/Dashboard/DashboardLogin'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

// const LoadableFirebaseLog = Loadable({
//   loader: () =>
//     import(/* webpackChunkName: 'firebaseLog' */ './components/FirebaseLog'),
//   loading() {
//     return <Spin indicator={antIcon} />;
//   }
// });

const LoadableNotFound = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'notFound' */ './components/NotFound'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableFonts = Loadable({
  loader: () => import(/* webpackChunkName: 'notFound' */ './components/Fonts'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableAnalytics = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'analytics' */ './components/Analytics'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableDataErasure = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'notFound' */ './components/DataErasure'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableTrackingServer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'trackingServer' */ './components/TrackingServer'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableAuditLogs = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'trackingServer' */ './components/Dashboard/AuditLogs'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableDashboardConfiguration = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'List Dashboard Configuration' */ './components/Dashboard/AdvanceConfiguration/List'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableCreateDashboardConfiguration = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Create Dashboard Configuration' */ './components/Dashboard/AdvanceConfiguration/Create'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableBetaRelease = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Dashboard Beta Release' */ './components/Dashboard/BetaRelease'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableLoginCreativesList = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'List Dashboard Login Creatives' */ './components/Dashboard/LoginCreatives/List'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableLoginCreativesCreate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Create Dashboard Login Creatives' */ './components/Dashboard/LoginCreatives/Create'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableWalkthroughConfigsList = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'List Walkthrough Configs' */ './components/Dashboard/WalkthroughConfigs/List'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableWalkthroughConfigsCreate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Create Walkthrough Config' */ './components/Dashboard/WalkthroughConfigs/Create'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableConfigureAWB = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Configure AWB' */ './components/Dashboard/ConfigureAWB'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableSimulation = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Simulation' */ './components/Simulation'),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableNotificationsMigration = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'NotificationsMigration' */ './components/NotificationsMigration'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableCodToPrepaid = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'COD To Prepaid' */ './components/CodToPrepaid'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableRedShiftLatency = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'RedShift Latency' */ './components/Reports/RedShiftLatency'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableDatabricksLatency = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'RedShift Latency' */ './components/Reports/DatabricksLatency'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableAccessControl = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: AccessControl List' */ './components/Dashboard/AccessControl/List'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableAccessControlCreate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AccessControl Create' */ './components/Dashboard/AccessControl/Create'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const LoadableManifestList = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Manifest List' */ './components/Manifest/ManifestList'
    ),
  loading() {
    return <Spin indicator={antIcon} />;
  }
});

const App = props => {
  const [, setCurrent] = useState('');
  const [user, setUser] = useState({
    isFetching: true,
    hasEnterpriseAccess: false,
    notificationsMigration: false
  });
  const emailid = cookies.get('email');

  useEffect(() => {
    if (emailid) {
      get({ url: `${APIs.USER.SELF_ACCESS}` }).then(response => {
        const { meta, result } = response.data;
        if (meta?.status === 200) {
          if (result.list.length > 0) {
            const {
              accessToAll,
              enterpriseIds,
              notificationsMigration
            } = result.list[0];
            if (accessToAll || enterpriseIds.length > 0) {
              setUser({
                isFetching: false,
                hasEnterpriseAccess: true,
                notificationsMigration: !!notificationsMigration
              });
            } else {
              setUser({
                isFetching: false,
                hasEnterpriseAccess: false,
                notificationsMigration: !!notificationsMigration
              });
            }
          } else {
            setUser({
              isFetching: false,
              hasEnterpriseAccess: false,
              notificationsMigration: false
            });
          }
        } else {
          setUser({
            isFetching: false,
            hasEnterpriseAccess: false,
            notificationsMigration: false
          });
        }
      });
    } else {
      setUser({
        isFetching: false,
        hasEnterpriseAccess: false,
        notificationsMigration: false
      });
    }
  }, []);

  const handleClick = e => {
    setCurrent({ current: e.key });
    props.history.push(e.key);
  };

  const avatarMenu = (
    <Menu>
      <Menu.Item onClick={logout}>Logout</Menu.Item>
    </Menu>
  );

  const name = cookies.get('name');

  if (user.isFetching) {
    return (
      <div className="absolute-center">
        <Spin tip="Loading..."></Spin>
      </div>
    );
  }

  return (
    <div className="app">
      <Helmet
        title={metadata.title}
        meta={metadata.meta}
        link={metadata.link}
        script={metadata.script}
        noscript={metadata.noscript}
      />
      <Row gutter={[16, 16]} className="margin-0">
        {props.location.pathname === '/tracking-health' ||
        props.location.pathname === '/login' ||
        props.location.pathname === '/validate-login' ? null : (
          <>
            <Col className="padding-0" span={4}>
              <aside>
                {/* <div className="sidebar-logo pt-3 d-flex justify-content-center align-items-center" /> */}
                <Menu
                  onClick={handleClick}
                  defaultSelectedKeys={[props.location.pathname]}
                  mode="inline"
                  theme="dark"
                >
                  <Menu.Item key="/jobs">Jobs</Menu.Item>
                  <SubMenu key="alerts" title="Alerts">
                    <Menu.Item key="/alerts">General</Menu.Item>
                    <Menu.Item key="/alerts/edd">EDD</Menu.Item>
                  </SubMenu>
                  {/* <Menu.Item key="/alerts">Alerts</Menu.Item> */}
                  <SubMenu key="mapping" title="Mapping">
                    <Menu.Item key="/status-mapping">Status</Menu.Item>
                    <Menu.Item key="/warehouse-mapping">Warehouse</Menu.Item>
                  </SubMenu>
                  <SubMenu key="reports" title="Reports">
                    <Menu.Item key="/report-metadata">
                      Report Documentation
                    </Menu.Item>
                    <Menu.Item key="/all-reports">All Reports</Menu.Item>
                    <Menu.Item key="/track-orders-reports-tz-setting">
                      Timezone Settings
                    </Menu.Item>
                    <Menu.Item key="/redshift-latency">
                      RedShift Latency
                    </Menu.Item>
                    <Menu.Item key="/databricks-latency">
                      Databricks Latency
                    </Menu.Item>
                  </SubMenu>
                  <SubMenu key="returns" title="Returns">
                    <Menu.Item key="/returns">Returns</Menu.Item>
                    <Menu.Item key="/returns/configs">Returns Config</Menu.Item>
                  </SubMenu>
                  <Menu.Item key="/shipment-log">Shipment Log</Menu.Item>
                  <SubMenu key="dashboard" title="Dashboard">
                    {user.hasEnterpriseAccess ? (
                      <Menu.Item key="/dashboard/login">
                        Enterprise Login
                      </Menu.Item>
                    ) : null}
                    <Menu.Item key="/dashboard/audit-log">
                      Audit Log Management
                    </Menu.Item>
                    <Menu.Item key="/dashboard/feature-requests">
                      Feature Requests
                    </Menu.Item>
                    <Menu.Item key="/dashboard/adv-configuration">
                      Advance Configuration
                    </Menu.Item>
                    <Menu.Item key="/dashboard/beta-release">
                      <a href="/dashboard/beta-release">Beta Release</a>
                    </Menu.Item>
                    {user.hasEnterpriseAccess ? (
                      <Menu.Item key="/dashboard/access-control">
                        <a href="/dashboard/access-control">Access Control</a>
                      </Menu.Item>
                    ) : null}
                    <Menu.Item key="/dashboard/configure-awb">
                      Configure AWB Series
                    </Menu.Item>
                    <Menu.Item key="/dashboard/login-creatives">
                      Login Page Creatives
                    </Menu.Item>
                    <Menu.Item key="/dashboard/walkthrough-configs">
                      Product Tour Walkthroughs
                    </Menu.Item>
                    <SubMenu key="email" title="Sample Email Templates">
                      <Menu.Item key="/dashboard/email-template">
                        All Templates
                      </Menu.Item>
                      <Menu.Item key="/dashboard/email-template/create">
                        Create New Template
                      </Menu.Item>
                    </SubMenu>
                    {user.hasEnterpriseAccess &&
                    user.notificationsMigration ? (
                      <Menu.Item key="/dashboard/notifications-migration">
                        Notifications Migration
                      </Menu.Item>
                    ) : null}
                    <SubMenu key="shipping-label" title="Shipping Label">
                      <Menu.Item key="/dashboard/shipping-labels/re-generate">
                        Re-Generate Label
                      </Menu.Item>
                      <Menu.Item key="/dashboard/sample-templates">
                        Sample Templates
                      </Menu.Item>
                      <Menu.Item key="/dashboard/sample-templates/create">
                        Create New Template
                      </Menu.Item>
                    </SubMenu>
                  </SubMenu>
                  <SubMenu key="tracking-page" title="Tracking Page">
                    <Menu.Item key="/tracking-page/fonts">Fonts</Menu.Item>
                    <Menu.Item key="/tracking-page/nps-config">
                      NPS - Brand Experience
                    </Menu.Item>
                    <Menu.Item key="/tracking-page/analytics">
                      Analytics
                    </Menu.Item>
                  </SubMenu>
                  <SubMenu key="billing" title="Billing">
                    <Menu.Item key="/billing">
                      <a href="/billing">View & Configure</a>
                    </Menu.Item>
                    <Menu.Item key="/billing/alerts">
                      <a href="/billing/alerts">Dashboard Alerts</a>
                    </Menu.Item>
                  </SubMenu>
                  <Menu.Item key="/manifest">Manifest Management</Menu.Item>
                  <Menu.Item key="/simulation">Simulation</Menu.Item>
                  <Menu.Item key="/cod-to-prepaid">COD To Prepaid</Menu.Item>
                  <Menu.Item key="/tracking-delay">Tracking Delay</Menu.Item>
                  <Menu.Item key="/oc-stats">OC Stats</Menu.Item>
                  <Menu.Item key="/data-erasure">Data Erasure</Menu.Item>
                </Menu>
              </aside>
            </Col>
          </>
        )}
        <Col
          span={
            props.location.pathname === '/tracking-health' ||
            props.location.pathname === '/login' ||
            props.location.pathname === '/validate-login'
              ? 24
              : 20
          }
          className="padding-0"
        >
          <Row>
            {props.location.pathname === '/tracking-health' ||
            props.location.pathname === '/login' ||
            props.location.pathname === '/validate-login' ? null : (
              <Col className="text-right padding-0" span={24}>
                <header>
                  <Dropdown overlay={avatarMenu} trigger={['click']}>
                    <a
                      className="ant-dropdown-link"
                      onClick={e => e.preventDefault()}
                      role="presentation"
                    >
                      <Avatar size={24} icon={<UserOutlined />} />
                      <span className="margin-left-10 margin-right-10">
                        {name}
                      </span>
                      <DownOutlined />
                    </a>
                  </Dropdown>
                </header>
              </Col>
            )}
            <Col span={24} className="main">
              <Switch>
                <Route exact path="/login" component={LoadableLogin} />
                <Route
                  exact
                  path="/validate-login"
                  component={LoadableValidateLogin}
                />
                <Route exact path="/jobs" component={auth(LoadableJobs)} />
                <Route exact path="/alerts/edd" component={auth(LoadableEDD)} />
                <Route exact path="/alerts" component={auth(LoadableAlerts)} />
                <Route
                  path="/status-mapping"
                  component={auth(LoadableStatusMapping)}
                />
                <Route
                  path="/warehouse-mapping"
                  component={auth(LoadableWarehouseMapping)}
                />
                <Route
                  path="/report-metadata"
                  component={auth(LoadableReportMetadata)}
                />
                <Route
                  path="/redshift-latency"
                  component={auth(LoadableRedShiftLatency)}
                />
                <Route
                  path="/databricks-latency"
                  component={auth(LoadableDatabricksLatency)}
                />
                <Route
                  path="/all-reports"
                  component={auth(LoadableActiveReports)}
                />
                <Route
                  path="/track-orders-reports-tz-setting"
                  component={auth(LoadableTimezoneSetting)}
                />
                <Route
                  path="/shipment-log"
                  component={auth(LoadableShipmentLog)}
                />
                {/* <Route
                  path="/dashboard-log"
                  component={auth(LoadableFirebaseLog)}
                /> */}
                <Route
                  exact
                  path="/billing/setup"
                  component={auth(LoadableSetupBilling)}
                />
                <Route
                  exact
                  path="/billing/payment"
                  component={auth(LoadableSetupPayment)}
                />
                <Route
                  exact
                  path="/billing"
                  component={auth(LoadableBilling)}
                />
                <Route
                  exact
                  path="/billing/alerts"
                  component={auth(LoadableBillingAlerts)}
                />
                <Route
                  path="/billing/alerts/:action(create|edit)/:id?"
                  component={auth(LoadableBillingCreateAlerts)}
                />
                <Route
                  path="/tracking-delay"
                  component={auth(LoadableTrackingDelay)}
                />
                <Route
                  path="/oc-stats"
                  component={auth(LoadableOrderCreationStats)}
                />
                <Route
                  path="/data-erasure"
                  component={auth(LoadableDataErasure)}
                />
                <Route
                  path="/returns/configs"
                  component={auth(LoadableReturnConfigs)}
                />
                <Route path="/returns" component={auth(LoadableQcParameters)} />
                <Route
                  path="/dashboard/email-template/create"
                  component={auth(LoadableCreateEmailTemplate)}
                />
                <Route
                  path="/dashboard/email-template"
                  component={auth(LoadableEmailTemplate)}
                />
                <Route
                  path="/release-notes"
                  component={auth(LoadableReleaseNotes)}
                />
                <Route
                  path="/tracking-health"
                  component={LoadableTrackingServer}
                />
                <Route
                  path="/dashboard/adv-configuration/:action"
                  component={auth(LoadableCreateDashboardConfiguration)}
                />
                <Route
                  path="/dashboard/adv-configuration/"
                  component={auth(LoadableDashboardConfiguration)}
                />
                <Route
                  path="/dashboard/beta-release"
                  component={auth(LoadableBetaRelease)}
                />
                <Route
                  path="/dashboard/audit-log"
                  component={auth(LoadableAuditLogs)}
                />
                <Route
                  path="/dashboard/feature-requests"
                  component={auth(LoadableFeatureRequests)}
                />
                <Route
                  path="/tracking-page/fonts"
                  component={auth(LoadableFonts)}
                />
                <Route
                  path="/tracking-page/nps-config"
                  component={auth(LoadableNPSConfig)}
                />
                <Route
                  path="/tracking-page/analytics"
                  component={auth(LoadableAnalytics)}
                />
                <Route
                  path="/dashboard/shipping-labels/create"
                  component={auth(LoadableCreateShippingLabels)}
                />
                <Route
                  path="/dashboard/shipping-labels/re-generate"
                  component={auth(LoadableRegenerateShippingLabel)}
                />
                <Route
                  path="/dashboard/shipping-labels/edit"
                  component={auth(LoadableEditShippingLabels)}
                />
                <Route
                  path="/dashboard/shipping-labels"
                  component={auth(LoadableShippingLabels)}
                />
                <Route
                  path="/dashboard/sample-templates/create"
                  component={auth(LoadableCreateSampleTemplate)}
                />
                <Route
                  path="/dashboard/sample-templates"
                  component={auth(LoadableSampleTemplates)}
                />
                <Route
                  exact
                  path="/dashboard/login-creatives"
                  component={auth(LoadableLoginCreativesList)}
                />
                <Route
                  path="/dashboard/login-creatives/edit/:region"
                  component={auth(LoadableLoginCreativesCreate)}
                />
                <Route
                  exact
                  path="/dashboard/walkthrough-configs"
                  component={auth(LoadableWalkthroughConfigsList)}
                />
                <Route
                  path="/dashboard/walkthrough-configs/edit/:sectionKey"
                  component={auth(LoadableWalkthroughConfigsCreate)}
                />
                <Route
                  path="/dashboard/configure-awb"
                  component={auth(LoadableConfigureAWB)}
                />
                <Route
                  path="/simulation"
                  component={auth(LoadableSimulation)}
                />
                {user.hasEnterpriseAccess && user.notificationsMigration ? (
                  <Route
                    path="/dashboard/notifications-migration"
                    component={auth(LoadableNotificationsMigration)}
                  />
                ) : null}
                <Route
                  path="/cod-to-prepaid"
                  component={auth(LoadableCodToPrepaid)}
                />
                <Route
                  path="/manifest"
                  component={auth(LoadableManifestList)}
                />
                <Route path="/" exact component={auth(LoadableShipmentLog)} />
                {user.hasEnterpriseAccess && (
                  <Route
                    path="/dashboard/login"
                    component={auth(LoadableDashboardLogin)}
                  />
                )}
                {user.hasEnterpriseAccess && (
                  <Route
                    path="/dashboard/access-control/:action(create|edit)/:id?"
                    component={auth(LoadableAccessControlCreate)}
                  />
                )}
                {user.hasEnterpriseAccess && (
                  <Route
                    path="/dashboard/access-control"
                    component={auth(LoadableAccessControl)}
                  />
                )}
                <Route component={auth(LoadableNotFound)} />
              </Switch>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default withRouter(App);
